import { CommentsAttachment, CommentType } from '../../models/comments'
import { CommentsActionTypes } from '../actions/comments'

export const COMMENTS_REDUCER_NAMESPACE = 'commentsReducer'

export const ROOT_PAGE_NUM = 'root'

export interface Topic {
    messageList: any[]
    loading: boolean
    loadingMore: boolean
    loadingMessage: boolean
    pageNumMap: Record<string, number>
    attachmentMap: Record<string, CommentsAttachment[]>
}

export interface CommentState {
    topicMap: Record<string, Topic>
    type: CommentType
}

const defaultState = {
    topicMap: {},
    type: null,
}

export default (state = defaultState, action: any) => {
    switch (action.type) {
        case CommentsActionTypes.INIT_TOPIC:
            return {
                ...state,
                topicMap: {
                    ...state.topicMap,
                    [action.topicId]: {
                        messageList: [],
                        totalCount: 0,
                        loading: false,
                        loadingMore: false,
                        loadingMessage: false,
                        pageNumMap: { [ROOT_PAGE_NUM]: 1 },
                        attachmentMap: {},
                    },
                },
            }
        case CommentsActionTypes.DELETE_TOPIC:
            const newTopicMap = { ...state.topicMap }
            delete newTopicMap[action.topicId]
            return {
                ...state,
                topicMap: { ...newTopicMap },
            }
        case CommentsActionTypes.SET_TOTAL_COUNT:
            return {
                ...state,
                topicMap: {
                    ...state.topicMap,
                    [action.payload.topicId]: {
                        ...state.topicMap[action.payload.topicId],
                        totalCount: action.payload.totalCount,
                    },
                },
            }
        case CommentsActionTypes.SET_MESSAGE_LIST:
            return {
                ...state,
                topicMap: {
                    ...state.topicMap,
                    [action.payload.topicId]: {
                        ...state.topicMap[action.payload.topicId],
                        messageList: action.payload.messageList,
                    },
                },
            }
        case CommentsActionTypes.SET_LOADING:
            return {
                ...state,
                topicMap: {
                    ...state.topicMap,
                    [action.payload.topicId]: {
                        ...state.topicMap[action.payload.topicId],
                        loading: action.payload.loading,
                    },
                },
            }
        case CommentsActionTypes.SET_LOADING_MORE:
            return {
                ...state,
                topicMap: {
                    ...state.topicMap,
                    [action.payload.topicId]: {
                        ...state.topicMap[action.payload.topicId],
                        loadingMore: action.payload.loading,
                    },
                },
            }
        case CommentsActionTypes.SET_LOADING_MESSAGE:
            return {
                ...state,
                topicMap: {
                    ...state.topicMap,
                    [action.payload.topicId]: {
                        ...state.topicMap[action.payload.topicId],
                        loadingMessage: action.payload.loading,
                    },
                },
            }
        case CommentsActionTypes.SET_ATTACHMENT_MAP:
            return {
                ...state,
                topicMap: {
                    ...state.topicMap,
                    [action.payload.topicId]: {
                        ...state.topicMap[action.payload.topicId],
                        attachmentMap: {
                            ...state.topicMap[action.payload.topicId]
                                .attachmentMap,
                            ...action.payload.attachmentMap,
                        },
                    },
                },
            }
        case CommentsActionTypes.SET_PAGE_NUM_MAP:
            return {
                ...state,
                topicMap: {
                    ...state.topicMap,
                    [action.payload.topicId]: {
                        ...state.topicMap[action.payload.topicId],
                        pageNumMap: {
                            ...state.topicMap[action.payload.topicId]
                                .pageNumMap,
                            ...action.payload.pageNumMap,
                        },
                    },
                },
            }
        case CommentsActionTypes.RESET_PAGE_NUM_MAP:
            return {
                ...state,
                topicMap: {
                    ...state.topicMap,
                    [action.payload.topicId]: {
                        ...state.topicMap[action.payload.topicId],
                        pageNumMap: {
                            ...action.payload.pageNumMap,
                        },
                    },
                },
            }
        case CommentsActionTypes.SET_TYPE:
            return {
                ...state,
                type: action.commentType,
            }
        default:
            return {
                ...state,
            }
    }
}
